import { render, staticRenderFns } from "./equipmentBorrowBack.vue?vue&type=template&id=2a17044c&scoped=true"
import script from "./equipmentBorrowBack.vue?vue&type=script&lang=js"
export * from "./equipmentBorrowBack.vue?vue&type=script&lang=js"
import style0 from "./equipmentBorrowBack.vue?vue&type=style&index=0&id=2a17044c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17044c",
  null
  
)

export default component.exports